export const EMAIL_MAX_CHARS = 320;
